var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 60.345,
    viewBox: "0 0 107 60.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-12 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    d: "M3.818,0H40.473A1.527,1.527,0,0,1,42,1.527V19.091A22.909,22.909,0,0,1,19.091,42h0A19.091,19.091,0,0,1,0,22.909V3.818A3.818,3.818,0,0,1,3.818,0Z",
    transform: "translate(50.632 38.948) rotate(45)",
    fill: "#01d85f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(40 78)",
    fill: "#f5f5f5",
    fontSize: 32,
    fontFamily: "JosefinSans-Medium, Josefin Sans",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "pro",
    transform: "translate(58 75)",
    fill: "#f5f5f5",
    fontSize: 32,
    fontFamily: "JosefinSans-Medium, Josefin Sans",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#01d85f"
  }, "ro")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "}",
    transform: "translate(106 84)",
    fill: "#f5f5f5",
    fontSize: 32,
    fontFamily: "JosefinSans-Medium, Josefin Sans",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "}")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "{",
    transform: "translate(12 81)",
    fill: "#01d85f",
    fontSize: 56,
    fontFamily: "JosefinSans-Medium, Josefin Sans",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "{")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.240828e816965db5d3ba09f955dda525.svg";
export { ForwardRef as ReactComponent };